import React from "react";
import { cn } from "@/utils/helpers";
import { MapZoomType } from "@/utils/types";
import { SvgIconProps } from "./SvgIcon";
import SvgIconZoomFit from "./SvgIconZoomFit";
import SvgIconZoomMe from "./SvgIconZoomMe";
import SvgIconZoomIn from "./SvgIconZoomIn";
import SvgIconZoomOut from "./SvgIconZoomOut";
import styles from "../Svg.module.css";

export interface SvgIconZoomProps extends SvgIconProps {
	type: MapZoomType;
}

export default function SvgIconZoom({
	type,
	className,
	...props
} : SvgIconZoomProps) {
	let SvgIconZoomComponent, height;
	switch(type) {
		case "fit":
			height = 112
			SvgIconZoomComponent = SvgIconZoomFit;
			break;
		case "me":
			SvgIconZoomComponent = SvgIconZoomMe;
			break;
		case "in":
			SvgIconZoomComponent = SvgIconZoomIn;
			break;
		case "out":
			SvgIconZoomComponent = SvgIconZoomOut;
			break;
	}
	return (
		<SvgIconZoomComponent
			height={height}
			className={cn(styles.SvgIconZoom, className)}
			{...props}
		/>
	)
}
